import React, { useEffect, useState } from 'react';

import Portal from '@atlaskit/portal/portal';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-atlaskit-theme
import { layers } from '@atlaskit/theme/constants';

const dest = React.createContext<HTMLDivElement | null | undefined>(undefined);
const Provider: React.Provider<HTMLDivElement | null | undefined> = dest.Provider;
const Consumer: React.Consumer<HTMLDivElement | null | undefined> = dest.Consumer;

export const PortalProvider = ({ children }: React.PropsWithChildren<{}>): React.JSX.Element => {
	const [portal, setPortal] = useState<HTMLDivElement | null | undefined>();
	const [isPortalReady, setIsPortalReady] = useState(false);

	useEffect(() => {
		if (portal !== null) {
			setIsPortalReady(true);
		}
	}, [portal]);

	return (
		<>
			{isPortalReady && <Provider value={portal}>{children}</Provider>}
			<Portal zIndex={layers.modal() + 1}>
				<div data-testid="forge-ui-portal" ref={setPortal} />
			</Portal>
		</>
	);
};

export { Consumer as PortalConsumer };
